export default __webpack_public_path__ + "static/media/external-direction.92bb7352.svg";